import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Footer() {
    return (
        <footer className="bg-blue-900 text-white pt-12 pb-6 mt-20">
            <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-right">

                {/* معلومات عامة */}
                <div>
                    <h3 className="text-xl font-bold mb-4">عن موبي كاشير</h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                         شركة  رائدة في تقديم حلول نقاط البيع والفوترة الإلكترونية، نعمل على تمكين المنشآت بمختلف أحجامها من إدارة عملياتها المالية والتجارية بكفاءة عالية، من خلال أنظمة كاشير ذكية، متوافقة مع متطلبات هيئة الزكاة والضريبة والجمارك. نُقدم لعملائنا تجربة متكاملة تشمل المتابعة اللحظية للفواتير، دعم فني مخصص، ولوحات تحكم تفاعلية لمتابعة الأداء واتخاذ القرارات بثقة.
                    </p>
                </div>

                {/* روابط سريعة */}
                <div>
                    <h3 className="text-xl font-bold mb-4">روابط مهمة</h3>
                    <ul className="space-y-2 text-sm">
                        <li><a href="#home" className="hover:text-yellow-400 transition">الرئيسية</a></li>
                        <li><a href="#features" className="hover:text-yellow-400 transition">المميزات</a></li>
                        <li><a href="#services" className="hover:text-yellow-400 transition">الخدمات</a></li>
                     </ul>
                </div>

                {/* معلومات التواصل + سوشيال */}
                <div className="space-y-4">
                    <h3 className="text-xl font-bold mb-4">تواصل معنا</h3>
                    <div className="text-sm space-y-2 text-gray-300" dir="rtl">
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <FaPhone className="text-blue-300" />
                            <span>+966531862180</span>
                        </div>
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <FaWhatsapp className="text-green-400" />
                            <a href="https://wa.me/966531862180" target="_blank" rel="noopener noreferrer" className="hover:text-white">تواصل واتساب</a>
                        </div>
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <FaEnvelope className="text-yellow-400" />
                            <span>hodhodmadina@gmail.com</span>
                        </div>
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <FaMapMarkerAlt className="text-red-400" />
                            <span> شارع الملك سلمان بن عبدالعزيز مدخل مصرف الراجحي ،  حفر الباطن </span>
                        </div>
                    </div>

                    {/* شبكات التواصل */}
                    <div className="flex justify-start space-x-4 rtl:space-x-reverse pt-4">
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaFacebook /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaTwitter /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaInstagram /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaLinkedin /></motion.a>
                    </div>
                </div>
            </div>

            {/* خط سفلي */}
            <div className="mt-12 border-t border-gray-500 pt-4 text-center text-sm text-gray-200">
                جميع الحقوق محفوظة © {new Date().getFullYear()} موبي كاشير
            </div>
        </footer>
    );
}
